import MapMarker from './map-marker';

export default MapMarker;
